/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Scale objects</h4>'

<p>Scale selected objects with exactness.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>D</b>: Quick scale body</li>
    <li class='shortcuts__item'><b>shift-D</b>: Scale</li>
</ul>`;

export default function ScaleTooltip() {
    return h('div', { innerHTML: body });
}
